import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnDestroy, OnInit, Output, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Departaments } from "app/core/models/departaments.model";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { CustomValidators, passwordValidator } from "app/shared/validators/custom.validators";
import { UsuarioService } from "app/core/services/usuario.service";
import { AuthService } from "app/core/auth/auth.service";

@Component({
    selector: "oab-alterar-senha-modal-v2",
    templateUrl: "./oab-alterar-senha-modal.component.html",
    styleUrls: ["./oab-alterar-senha-modal.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule],
})
export class OabAlterarSenhaModalV2Component implements OnInit, OnDestroy {
  private formBuilder = inject(FormBuilder);
  private usuarioService = inject(UsuarioService);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  @Input()
  showModal = false;

  @Output() handleModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  organizacoes: Departaments[];
  selecaoForm: FormGroup;
  subscptions: Subscription[] = new Array<Subscription>();
  setoresPorOrg: any[];

  ngOnInit() {
  this.buildForm();
  }
  buildForm() {
    this.selecaoForm = this.formBuilder.group(
      {
        password: ["", [Validators.required]],
        newPassword: ["", [Validators.required, CustomValidators.password]],
        confNewPassword: ["", [Validators.required]],
      }
    );
  }

  ngOnDestroy() {
    this.subscptions.forEach((item) => item.unsubscribe());
  }

  closeModal() {
    this.handleModal.emit(false);
    this.selecaoForm.reset();
    this.buildForm();
  }

  atualizar() {
    if(this.selecaoForm.valid) {  
      const user = this.usuarioService.getUser();
      this.usuarioService.updatePassword(user.email, this.selecaoForm.get('newPassword').value, this.selecaoForm.get('password').value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
        this.authService.logout();
      });
    }
  }
}
